import { useEffect, useState, ChangeEvent } from "react";
import { InputText, type InputTextProps } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";

import { CloseIcon, SearchIcon } from "@/components/atoms/icons";

type SelectFilterProps = Omit<InputTextProps, "onChange"> & {
  onChange?: (value: string) => void;
};

export function SelectFilter({
  onChange,
  value: valueProp,
  invalid,
  placeholder,
  ...props
}: Readonly<SelectFilterProps>) {
  const [value, setValue] = useState<string>("");

  useEffect(() => {
    setValue(valueProp ?? "");
  }, [valueProp]);

  const hasValue = value.length > 0;

  const clearValue = () => {
    setValue("");
    onChange?.("");
  };

  const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    onChange?.(e.target.value);
  };

  return (
    <div className="flex flex-col">
      {placeholder && <label className="mb-[0.25rem] inline-block text-sm">{placeholder}</label>}
      <IconField className="w-full">
        <InputIcon>
          {hasValue && (
            <CloseIcon
              className="cursor-pointer fill-urbix-gray-600 hover:fill-primary-800"
              size={20}
              onClick={clearValue}
            />
          )}

          {!hasValue && <SearchIcon className="fill-urbix-gray-600" size={20} />}
        </InputIcon>
        <InputText
          invalid={invalid}
          pt={{
            root: [
              "border bg-white border-urbix-gray-600 w-full placeholder:not-italic",
              { "border-error text-urbe-error": invalid },
            ],
          }}
          {...props}
          value={value}
          onChange={handleOnChange}
        />
      </IconField>
    </div>
  );
}
